import { combineReducers } from "redux";
import RoutesReducer from './routes.reducer';
import RouteGroupsReducer from './route-group.reducer'

export default combineReducers({
    routeStore: RoutesReducer,
    routeGroupStore: RouteGroupsReducer
})